/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHighlight = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m6.634 13.758.232 3.598L5.5 21H9l1.33-1.644 3.232-1.598L19.196 6 14 3 6.634 13.758zm7.97-8.1 1.988 1.148-4.333 9.045-3.321-1.917 5.666-8.276z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHighlight as Highlight };
